import React from "react";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import "../sda/styles.scss";
import { cardBackgroundColor } from "../../config/palette";
import { H3 } from "../typography";
import { Text } from "@amzn/stencil-react-components/text";
import { Link } from "@amzn/stencil-react-components/link";
import {
  TooltipAlignment,
  withTooltip,
} from "@amzn/stencil-react-components/tooltip";
import { IconQuestionCircle } from "@amzn/stencil-react-components/icons";

const linkStyle = {
  cursor: "pointer",
};

interface StartDateCardHeaderProps {
  startDate?: string;
  startTime?: string;
  startDateStatus?: string;
  onViewDetailsClick: () => void;
}

const IconWithTooltip = withTooltip()(IconQuestionCircle);

export const StartDateCardHeader = ({
  startDate,
  startTime,
  startDateStatus,
  onViewDetailsClick,
}: StartDateCardHeaderProps) => {
  const message =
    startDateStatus === "TENTATIVE" ? (
      <H3 fontSize="T200" fontWeight="bold">
        Your tentative first day onsite is on {startDate} {startTime}{" "}
        <span className="tooltip-icon-in-text">
          <IconWithTooltip
            isInline={true}
            tooltipAlignment={TooltipAlignment.Center}
            tooltipPosition="bottom"
            tooltipText="Your first day is contingent on
        the results of your background check and drug test."
          />
        </span>{" "}
      </H3>
    ) : (
      <H3 fontSize="T200" fontWeight="bold">
        Your confirmed first day onsite is on {startDate} {startTime}
      </H3>
    );

  return (
    <Col backgroundColor={cardBackgroundColor} padding="1rem">
      <Row padding="0.2rem">
        <Col padding="0.2rem">{message}</Col>
      </Row>
      <Row padding="0.2rem">
        <Col padding="0.2rem">
          <Text fontSize="T200">
            Learn more about your new workplace, duties and responsibilities. We
            look forward to welcoming you.
          </Text>
        </Col>
      </Row>
      <Row padding="0.2rem">
        <Col padding="0.2rem">
          <Link
            textDecoration="none"
            style={linkStyle}
            onClick={onViewDetailsClick}
          >
            <Text fontSize="T200">View details</Text>
          </Link>
        </Col>
      </Row>
    </Col>
  );
};
